export default __webpack_public_path__ + "static/media/ipad_BAT.1f6ce21b.png";